// This file was generated on Tue Sep 14 2021 20:15:56 GMT+0300 (Moscow Standard Time)
export const appVersion = '1.2.354';
export const buildDate = '09/14/2021 20:15:56';
